import { render, staticRenderFns } from "./WorkerChannels.vue?vue&type=template&id=722b2a24&"
import script from "./WorkerChannels.vue?vue&type=script&lang=js&"
export * from "./WorkerChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports